import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import AiGenerativeTextIcon from '@atlaskit/icon-lab/core/ai-generative-text';
import { fg } from '@atlaskit/platform-feature-flags';

import { BrainstormIcon } from '../../../../icons/prompt/brainstorm';
import { createInsertAtCurrentPosition } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptions,
	EditorPluginAIConfigItem,
} from '../../config-items';

export const createDraftReply = (issueId?: string): EditorPluginAIConfigItem => ({
	key: CONFIG_ITEM_KEYS.SUGGEST_REPONSE,
	title: aiConfigItemMessages.draftReplyTitle,
	description: aiConfigItemMessages.draftReplyDescription,
	icon: () => (
		<BrainstormIcon size={fg('platform_editor_ai_aifc_patch_beta_2') ? 'small' : 'medium'} />
	),
	endpoint: `/gateway/api/firebolt/1/agent-response/issues/${issueId}/stream`,
	intentSchemaId: 'brainstorm_intent_schema.json',
	featureId: 'brainstorm',
	alwaysNoDocAndSelection: true,
	actions: {
		empty: [
			createInsertAtCurrentPosition({
				appearance: 'primary',
			}),
		],
		selection: [
			createInsertAtCurrentPosition({
				appearance: 'primary',
			}),
		],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
	statusLozengeType: fg('platform_remove_jsm_beta_tags') ? undefined : 'beta',
});

export const createDraftReplyWithOptions = (
	issueId?: string,
): EditorPluginAIConfigItemWithOptions => ({
	config: createDraftReply(issueId),
	triggers: { empty: { enabled: true, docMinSize: 0 }, selection: { enabled: false } },
});

export const createDraftReplyPill = (issueId?: string): EditorPluginAIConfigItem => ({
	key: CONFIG_ITEM_KEYS.DRAFT_REPLY_PILL,
	title: aiConfigItemMessages.draftReplyHeroPromptTitle,
	description: aiConfigItemMessages.draftReplyHeroPromptDescription,
	icon: () => <AiGenerativeTextIcon size="small" label="Suggest reply" />,
	endpoint: `/gateway/api/firebolt/1/agent-response/generate`,
	intentSchemaId: 'brainstorm_intent_schema.json',
	featureId: 'brainstorm',
	alwaysNeedDoc: false,
	alwaysNoDocAndSelection: false,
	getRequestPayload: ({ doc, selection }) => {
		return {
			userText: selection || doc,
			category: 'IMPROVE_WRITING',
			commentType: 'CUSTOMER_REPLY',
			issueId: issueId,
			pills: [],
		};
	},
	actions: {
		empty: [
			createInsertAtCurrentPosition({
				appearance: 'primary',
			}),
		],
		selection: [
			createInsertAtCurrentPosition({
				appearance: 'primary',
			}),
		],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
});

export const createDraftReplyPillWithOptions = (
	issueId?: string,
): EditorPluginAIConfigItemWithOptions => ({
	config: createDraftReplyPill(issueId),
	triggers: { empty: { enabled: true, docMinSize: 0 }, selection: { enabled: true } },
});
